import { restApiRP } from "@plannel/services/utils/rest-api";

const getDistributionNetwork = () => {
  return restApiRP.get("/api/distribution-network");
};

/**
 * 링크(BOD) 하나를 타고 흐르는 품목. 그래프에서 선을 눌렀을 때만 부른다 —
 * 링크마다 품목 목록을 미리 실어 내리면 응답이 z_bod_item 전체 크기가 된다.
 */
const getLinkItems = bodId => {
  return restApiRP.get("/api/distribution-network/link-items", { params: { bodId } });
};

/**
 * 거점 하나를 드나드는 품목(중복 제거). 그래프에서 거점을 눌렀을 때만 부른다.
 * 허브는 품목이 많을 수 있어 서버가 잘라 내고 `truncated` 로 알려 준다.
 */
const getLocationItems = locCd => {
  return restApiRP.get("/api/distribution-network/location-items", { params: { locCd } });
};

/**
 * 품목 하나가 흐르는 BOD id 목록. 인스펙터의 「따라가기」가 쓴다.
 * 그래프는 이 id 로 선만 칠하므로(거르지 않는다) 전체 네트워크는 다시 받지 않는다.
 */
const getItemBods = itemCd => {
  return restApiRP.get("/api/distribution-network/item-bods", { params: { itemCd } });
};

const rpDistributionNetworkService = {
  getDistributionNetwork,
  getLinkItems,
  getLocationItems,
  getItemBods
};

export default rpDistributionNetworkService;